<div class="grid">
    <div class="col-12">
        <div class="card h-full">
            <div class="relative flex justify-content-center align-items-center mb-3">
                <ami-head [settings]="settingsAmiHead"></ami-head>

                <div class="absolute right-0 top-0 mt-2 mr-2">
                    <button pButton label="Nueva Exportación" icon="pi pi-plus" (click)="showWizard()"></button>
                </div>
            </div>

            <!-- ✅ OVERLAY LOADING -->
            <div class="relative">

                <!-- ✅ Overlay paginación -->
                <div *ngIf="loadingTable"
                    class="absolute top-0 left-0 w-full h-full flex justify-content-center align-items-center"
                    style="background: rgba(255, 255, 255, 0.55); z-index: 998;">
                    <p-progressSpinner></p-progressSpinner>
                    <span class="ml-3 font-bold">Cargando...</span>
                </div>

                <!-- ✅ Overlay descargas (ya lo tienes) -->
                <div *ngIf="loadingDownload"
                    class="absolute top-0 left-0 w-full h-full flex flex-column justify-content-center align-items-center"
                    style="background: rgba(255, 255, 255, 0.7); z-index: 999;">
                    <p-progressSpinner></p-progressSpinner>
                    <p class="mt-3 font-bold">{{ loadingMessage }}</p>
                </div>

                <ami-table-actions [settings]="table.settings" [data]="table.data" [actions]="table.actions"
                    (action)="onReciveAction($event)">
                </ami-table-actions>

            </div>
        </div>
    </div>
</div>

<p-dialog header="Kardex valorizado" [(visible)]="displayDetailModal" [modal]="true"
    [style]="{ width: '90vw', maxWidth: '1200px' }" appendTo="body">
    <app-step-preview *ngIf="displayDetailModal && selectedHistoryItem" [businessId]="selectedHistoryItem.businessId"
        [period]="selectedHistoryItem.period">
    </app-step-preview>
</p-dialog>